import { Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";

/** Shared card heading treatment for "Print & format" and "Preview" -- bold,
 * all caps, a touch larger than body text and a hair of letter-spacing so
 * the caps read as a heading rather than shouting. */
export function CardTitle({ children }: { children: ReactNode }): ReactElement {
  return (
    <Typography
      variant="subtitle1"
      sx={{
        fontWeight: 700,
        fontSize: "1.1rem",
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        mb: 2,
      }}
    >
      {children}
    </Typography>
  );
}

/** A small secondary-colored label above a control group (Print format,
 * File type, Print size) -- plain sentence case, not the shouty small-caps
 * overline this screen used to render. `mt` defaults to a gap from the
 * control group above; the first eyebrow under the card title passes 0. */
export function Eyebrow({ children, mt = 3 }: { children: ReactNode; mt?: number }): ReactElement {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        display: "block",
        mt,
        mb: 1,
        fontWeight: 600,
      }}
    >
      {children}
    </Typography>
  );
}
